import { makeStyles, createStyles, Theme } from '@material-ui/core';
import transitions from '@material-ui/core/styles/transitions';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    aiHomePageContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: '436px',
      position: 'relative',
      background: theme.palette.home.backgroundColor,
      boxShadow: '0px -12px 50px 0px rgba(0, 0, 0, 0.25) inset',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        height: 'fit-content',
      },
    },
    card: {
      border: '1px solid rgba(166, 173, 172, 0.3)',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
      flexShrink: '0',
      width: '280px',
      height: '340px',
      cursor: 'pointer',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.20)',
        border: '1px solid rgba(166, 173, 172, 0.30)',
        transitions: 'border 0.5s, background 0.5s',
      },
    },
    imageContainer: {
      width: '100%',
      height: '164px',
      position: 'relative',
    },
    imageWrapper: {
      backgroundColor: '#e0e8e6',
      borderRadius: '8px 8px 0 0',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
    },
    logoImage: {
      objectFit: 'contain',
      width: '278px',
      height: '160px',
    },
    previewImage: {
      borderRadius: '4px',
      width: '261px',
      height: '144px',
      position: 'absolute',
      top: '10px',
      left: '10px',
    },
    browserMockup: {
      backgroundColor: '#fbfbfb',
      borderRadius: '4px',
      width: '257px',
      height: '140px',
      position: 'absolute',
      top: '12px',
      left: '12px',
    },
    browserHeader: {
      backgroundColor: '#fff',
      borderBottom: '1px solid rgba(0,0,0,0.1)',
      height: '9px',
    },
    iconCircle: {
      backgroundColor: '#fff',
      borderRadius: '40px',
      width: '80px',
      height: '80px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: '60px',
      left: '180px',
      boxShadow: '0 0 20px rgba(0, 0, 0, 0.12)',
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '16px',
    },
    category: {
      color: '#1a1a1a',
      backgroundColor: '#e0e8e6',
      borderRadius: '20px',
      width: 'fit-content',
      padding: '4px 8px',
      fontSize: '12px',
      lineHeight: '16px',
    },
    title: {
      color: '#fff',
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '24px',
      margin: 0,
    },
    description: {
      color: 'rgba(255, 255, 255, 0.6)',
      height: '80px',
      fontSize: '16px',
      lineHeight: '20px',
      overflow: 'hidden',
      margin: 0,
    },
    underline: {
      backgroundColor: '#17e88f',
      height: '2px',
      marginTop: '0px',
    },
    container: {
      color: '#fff',
      maxWidth: 'none',
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: '20px',
      overflow: 'hidden',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px',
    },
    showCaseTitle: {
      color: '#e3e3e3',
      fontSize: '24px',
      lineHeight: '24px',
      fontWeight: 350,
      fontStyle: 'normal',
      margin: 0,
      '@media (max-width: 640px)': {
        fontSize: '20px',
      },
    },
    navigationControls: {
      display: 'flex',
      gap: '16px',
    },
    cardsContainer: {
      display: 'flex',
      gap: '16px',
      padding: '4px',
      overflowX: 'hidden',
      scrollbarWidth: 'none',
      cursor: 'grab',
      '-webkit-touch-callout': 'none', /* iOS Safari */
      '-webkit-user-select': 'none', /* Safari */
      '-khtml-user-select': 'none', /* Konqueror HTML */
      '-moz-user-select': 'none', /* Firefox */
      '-ms-user-select': 'none', /* Internet Explorer/Edge */
      'user-select': 'none', /* Non-prefixed version, currently supported by Chrome and Opera */
    },

    cardContainer: {
      backgroundColor: '#000',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '16px',
      width: '343px',
      maxWidth: 'none',
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'flex',
      '@media (max-width: 991px)': {
        width: '100%',
        maxWidth: '991px',
        padding: '0 16px',
      },
      '@media (max-width: 640px)': {
        maxWidth: '640px',
        padding: '0 12px',
      },
    },
    contentWrapper: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '8px',
      width: '100%',
      display: 'flex',
    },
    textContainer: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '8px',
      width: '100%',
      display: 'flex',
    },
    subtitle: {
      color: '#fff9',
      letterSpacing: '0.08px',
      fontFamily: 'Inter, sans-serif',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '24px',
      '@media (max-width: 640px)': {
        fontSize: '14px',
        lineHeight: '20px',
      },
    },
    inputDesignTitle: {
      color: '#fff',
      letterSpacing: '-0.56px',
      fontFamily: 'Inter, sans-serif',
      fontSize: '28px',
      fontWeight: 400,
      lineHeight: '36px',
      margin: '8px 0px 16px 0px',
      '@media (max-width: 640px)': {
        fontSize: '24px',
        lineHeight: '32px',
      },
    },
    inputDesignSubTitle: {
      margin: '0px',
    },
    exploreButton: {
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      padding: '6px 16px',
      display: 'flex',
      position: 'relative',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
    },
    buttonBackground: {
      backgroundColor: '#ffffff3d',
      borderRadius: '4px',
      width: '88px',
      height: '36px',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    buttonText: {
      color: '#fff',
      textAlign: 'center',
      padding: '7px 0 6px',
      fontFamily: 'Inter, sans-serif',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '16px',
      position: 'relative',
    },
    inputDesignSection: {
      display: 'flex',
      flexDirection: 'column',
      color: '#fff',
      paddingLeft: '25px',
      paddingTop: '24px',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingRight: '24px',
        paddingTop: '16px',
      },
    },
    aiHomeInputContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      height: '36px',
      '& > button': {
        backgroundColor: `${theme.palette.home.buttonColor} !important`,
      },
    },
    aiHomeBackgroundLines: {
      position: 'absolute',
      top: '20%',
      height: '2px',
      width: '456px',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(153, 153, 153, 0.00) 100%)',
      border: 'none',
    },
    aiHomeBackgroundLines2: {
      position: 'absolute',
      bottom: '18%',
      height: '2px',
      width: '456px',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(153, 153, 153, 0.00) 100%)',
      border: 'none',
    },
    aiHomeBackgroundLines3: {
      position: 'absolute',
      top: '0',
      height: '100%',
      width: '2px',
      left: '30%',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(153, 153, 153, 0.00) 100%)',
      border: 'none',
    },
    inputDesignIconDiv: {
      '& > svg': {
        width: '36px',
        height: '36px',
        [theme.breakpoints.down('md')]: {
          width: '24px',
          height: '24px',
        },
      },
    },
  }),
);
